(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-timer')) {
    class CartTimer extends HTMLElement {
      connectedCallback() {
        const minutes = parseInt(this.dataset.minutes, 10) || 10;
        this._seconds = minutes * 60;
        this._render();
        this._interval = setInterval(() => {
          if (this._seconds > 0) {
            this._seconds--;
            this._render();
          } else {
            clearInterval(this._interval);
          }
        }, 1000);
      }

      disconnectedCallback() {
        clearInterval(this._interval);
      }

      _render() {
        const m = Math.floor(this._seconds / 60);
        const s = this._seconds % 60;
        this.textContent = `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
      }
    }
    customElements.define('cart-timer', CartTimer);
  }
  } catch(e) { console.error(e); }
})();

})();
